import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import routes from "routes";
import footerRoutes from "footer.routes";
import Axios from "utils/Axios";
import MKTypography from "components/MKTypography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import getNavRoutes from "../../navroutes";
import "./EventImage.css";
import { buildEventPath } from "utils/seo";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const galleryImageUrl = (image) => {
  if (!image) return "";
  const parts = image.split("_");
  if (parts.length >= 3) {
    parts.splice(3, 0, "img_1200");
    image = parts.join("_");
  }
  return `${process.env.REACT_APP_BASE_IMAGE_URL}gallery/${image}`;
};

const EventImage = () => {
  const navigate = useNavigate();
  const { imgeRef, eventId, imageId } = useParams();
  const [singleImage, setSingleImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [images, setImages] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [show, setShow] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [fullscreenImageLoading, setFullscreenImageLoading] = useState(false);
  const [touchStartX, setTouchStartX] = useState(0);
  const token = localStorage.getItem("token");
  const [routes, setNavRoutes] = useState([]);
  const currentPageUrl = window.location.href;

  const getSingleImage = () => {
    setLoading(true);
    Axios.get(`?type=eventSingleMedia&event_id=${eventId}&image_id=${imageId}`)
      .then((response) => {
        const image = response.data;
        setSingleImage(image);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching single image:", error);
        setError("Error fetching image");
        setLoading(false);
      });
  };

  const getEventMedia = () => {
    Axios.get(`?type=eventMedia&event_id=${eventId}`)
      .then((response) => {
        setImages(response.data || []);
      })
      .catch((error) => {
        console.error("Error fetching event media:", error);
      });
  };

  const nextImage = () => {
    if (!isLoggedIn) {
      setShow(true);
      return;
    }
    let index = images.findIndex((img) => img.title === singleImage.title);
    if (index !== -1 && index < images.length - 1) {
      index += 1;
    } else {
      index = 0;
    }
    const followingImage = images[index];
    navigate(`/event-image/${followingImage.title}/${eventId}/${followingImage.id}`);
  };

  const prevImage = () => {
    if (!isLoggedIn) {
      setShow(true);
      return;
    }
    let index = images.findIndex((img) => img.title === singleImage.title);
    if (index !== -1 && index > 0) {
      index -= 1;
    } else {
      index = images.length - 1;
    }
    const followingImage = images[index];
    navigate(`/event-image/${followingImage.title}/${eventId}/${followingImage.id}`);
  };

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;
    const threshold = 50; // minimum distance for swipe

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        // Swiped left, go to next image
        nextImage();
      } else {
        // Swiped right, go to previous image
        prevImage();
      }
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    setNavRoutes(getNavRoutes(token ? true : false));
    if (token) {
      setIsLoggedIn(true);
      getEventMedia();
    }
  }, [eventId, token]);

  useEffect(() => {
    getSingleImage();
    if (fullscreenOpen) {
      setFullscreenImageLoading(true);
    }
  }, [imageId]);

  return (
    <>
      <DefaultNavbar routes={routes} relative center />
      <div className="grid place-items-center px-4 md:py-6 py-2">
        {loading && <p>Loading image...</p>}
        {error && <p>{error}</p>}

        {/* Top Bar */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full max-w-6xl gap-4 mb-6">
          <Button
            variant="text"
            onClick={() => navigate(buildEventPath(eventId, singleImage?.event_title || "event"))}
            color="secondary"
            className="flex items-center gap-1"
          >
            <span className="material-icons-outlined">chevron_left</span> Back to event
          </Button>

          <div className="flex flex-wrap items-center gap-2 text-center sm:text-left">
            <MKTypography variant="h5">{singleImage?.event_title} /</MKTypography>
            <MKTypography variant="h5">
              {singleImage?.event_date} {singleImage?.venue_name ? ' - ' + singleImage?.venue_name : ' - ' + singleImage?.event_address}
            </MKTypography>
            {/* Share Button (above image) */}
            {!loading && singleImage && (
              <div className="flex justify-end mt-1 px-2">
                <IconButton
                  color="secondary"
                  onClick={() => setShareModalOpen(true)}
                  size="small"
                  sx={{
                    border: '1px solid',
                    borderColor: 'secondary.main',
                    borderRadius: '8px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    paddingLeft: '4px',
                    paddingRight: '4px',
                  }}
                >
                  <span className="material-icons-outlined text-sm">share</span>
                </IconButton>
              </div>
            )}
          </div>
        </div>


        {/* Image + Buttons */}
        <div className="w-full max-w-6xl flex flex-col sm:flex-row items-center justify-center gap-4">
          {/* Buttons on top (mobile only) */}
          <div className="flex sm:hidden gap-4 mb-4">
            <button
              className="bg-purple-500 text-white px-3 py-2 flex items-center rounded-full"
              onClick={prevImage}
            >
              <span className="material-icons-outlined">chevron_left</span>
            </button>
            <button
              className="bg-purple-500 text-white px-3 py-2 flex items-center rounded-full"
              onClick={nextImage}
            >
              <span className="material-icons-outlined">chevron_right</span>
            </button>
          </div>

          {/* Prev Button (desktop only) */}
          <button
            className="hidden sm:flex bg-purple-500 text-white px-3 py-2 items-center rounded-full"
            onClick={prevImage}
          >
            <span className="material-icons-outlined">chevron_left</span>
          </button>

          {/* Image */}
          {!loading && singleImage && (
            <div className="w-full sm:max-w-4xl flex justify-center px-2">
              <img
                className="event-image cursor-pointer"
                src={galleryImageUrl(singleImage?.title)}
                alt={singleImage?.title}
                onClick={() => setFullscreenOpen(true)}
                style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
              />
            </div>
          )}

          {/* Next Button (desktop only) */}
          <button
            className="hidden sm:flex bg-purple-500 text-white px-3 py-2 items-center rounded-full"
            onClick={nextImage}
          >
            <span className="material-icons-outlined">chevron_right</span>
          </button>
        </div>
      </div>

      <React.Fragment>
        {/* Login Warning Dialog */}
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          className="p-5"
        >
          <DialogTitle>{"Warning"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              To view all images, please{" "}
              <a href="/sign-up/" className="text-blue-500">
                Create a free account
              </a>{" "}
              or{" "}
              <a href="/sign-in/" className="text-blue-500">
                log in here
              </a>
              .
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* Share Modal */}
        <Dialog
          open={shareModalOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setShareModalOpen(false)}
          aria-describedby="share-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>
            {"Share This Image"}
            <IconButton
              aria-label="close"
              onClick={() => setShareModalOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <span className="material-icons-outlined">close</span>
            </IconButton>
          </DialogTitle>
          <DialogContent className="share-modal-content">
            <DialogContentText id="share-dialog-description" sx={{ mb: 2 }}>
              Share this image with friends or copy the link
            </DialogContentText>
            
            {/* WhatsApp Share Option */}
            <div 
              className="share-option"
              onClick={() => {
                const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`Check out this image from ${singleImage?.event_title}: ${currentPageUrl}`)}`;  
                window.open(whatsappUrl, '_blank');
              }}
            >
              <div className="share-option-icon whatsapp-icon">
                <span className="material-icons-outlined">whatsapp</span>
              </div>
              <div className="share-option-text">Share on WhatsApp</div>
            </div>
            
            {/* Copy Link Option */}
            <div 
              className="share-option"
              onClick={() => {
                navigator.clipboard.writeText(currentPageUrl);
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 3000);
              }}
            >
              <div className="share-option-icon copy-icon">
                <span className="material-icons-outlined">content_copy</span>
              </div>
              <div className="share-option-text">Copy Link</div>
            </div>
            
            {copySuccess && (
              <div className="copy-success">
                Link copied to clipboard!
              </div>
            )}
          </DialogContent>
        </Dialog>

        {/* Fullscreen Image Modal */}
        <Dialog
          open={fullscreenOpen}
          onClose={() => setFullscreenOpen(false)}
          maxWidth={false}
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.95)',
              boxShadow: 'none',
              margin: 0,
              maxWidth: '100vw',
              maxHeight: '100vh',
              width: '100vw',
              height: '100vh',
            }
          }}
        >
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={() => setFullscreenOpen(false)}
            sx={{
              position: 'absolute',
              right: 20,
              top: 20,
              color: '#000',
              backgroundColor: '#ecececff',
              '&:hover': {
                backgroundColor: '#ffffffff',
              },
              zIndex: 10,
              width: 48,
              height: 48,
            }}
          >
            <span className="material-icons-outlined">close</span>
          </IconButton>

          {/* Previous Button (Desktop) */}
          <IconButton
            aria-label="previous"
            onClick={prevImage}
            sx={{
              position: 'absolute',
              left: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#000',
              backgroundColor: '#ecececff',
              '&:hover': {
                backgroundColor: '#ffffffff',
              },
              zIndex: 10,
              width: 48,
              height: 48,
              display: { xs: 'none', sm: 'flex' },
            }}
          >
            <span className="material-icons-outlined">chevron_left</span>
          </IconButton>

          {/* Next Button (Desktop) */}
          <IconButton
            aria-label="next"
            onClick={nextImage}
            sx={{
              position: 'absolute',
              right: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#000',
              backgroundColor: '#ecececff',
              '&:hover': {
                backgroundColor: '#ffffffff',
              },
              zIndex: 10,
              width: 48,
              height: 48,
              display: { xs: 'none', sm: 'flex' },
            }}
          >
            <span className="material-icons-outlined">chevron_right</span>
          </IconButton>

          <DialogContent
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              overflow: 'hidden',
              position: 'relative',
            }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {/* Loading Overlay */}
            {fullscreenImageLoading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.07)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 5,
                }}
              >
                <div className="fullscreen-loader">
                  <span className="material-icons-outlined" style={{ fontSize: '48px', color: 'white', animation: 'spin 1s linear infinite' }}>refresh</span>
                </div>
              </div>
            )}

            {singleImage && (
              <img
                src={galleryImageUrl(singleImage?.title)}
                alt={singleImage?.title}
                onLoad={() => setFullscreenImageLoading(false)}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100vh',
                  objectFit: 'contain',
                  userSelect: 'none',
                  WebkitUserSelect: 'none',
                  opacity: fullscreenImageLoading ? 0 : 1,
                  transition: 'opacity 0.3s ease',
                }}
              />
            )}
          </DialogContent>

          {/* Mobile Navigation Hint */}
          <div
            sx={{
              position: 'absolute',
              bottom: 20,
              left: '50%',
              transform: 'translateX(-50%)',
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '12px',
              display: { xs: 'block', sm: 'none' },
            }}
            className="flex sm:hidden gap-2 text-center text-xs text-white opacity-70"
            style={{
              position: 'absolute',
              bottom: '20px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '8px',
              textAlign: 'center',
              fontSize: '12px',
              color: 'rgba(255, 255, 255, 0.7)',
            }}
          >
            <span>← Swipe →</span>
          </div>
        </Dialog>
      </React.Fragment>

      <MKBox pt={6} px={1} sx={{ mt: 5 }}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
};

export default EventImage;